import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
import { pains } from '../data/content';
import { SectionTitle } from './SectionTitle';
export function PainSection() {
  return <section className="bg-white px-5 py-10 sm:px-8 lg:py-14" data-id="element-66" data-mp="2uy5mizx0gxyj">
      <div className="mx-auto w-full max-w-content" data-id="element-67" data-mp="2uxvw5b820osb">
        <SectionTitle align="left" className="max-w-prose" data-id="element-68" data-mp="2yz7nbl6kti2m">
          ESTE LIBRO ES PARA TI SI...
        </SectionTitle>

        <ul className="mt-6 grid gap-3 lg:grid-cols-2" data-id="element-69" data-mp="2l7axjnsdrk9e">
          {pains.map((pain, i) => <li key={pain} className={i === 4 ? 'lg:col-span-2' : ''} data-id="element-70" data-mp="2pzc8n6dtb4xu" data-mpi={i}>
              <div className="flex h-full items-center gap-4 rounded-2xl bg-blush/70 px-6 py-5" data-id="element-71" data-mp="2ba6cxse6nwup">
                <ChevronRightIcon aria-hidden="true" className="h-6 w-6 shrink-0 text-coral" strokeWidth={2.5} data-id="element-72" data-mp="2g996ogopqgnd" />
                <p className="font-sans text-[17px] font-bold leading-snug text-ink" data-id="element-73" data-mp="229qcyswnf7ul">
                  {pain}
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}